import * as preact from "preact";

import models from "models/models";
import * as pushNotifications from "../pushNotifications";
import * as utils from "../shared/utils";

// Types for props
type Props = {
  appRouter: any;
};

// Types for state
type State = {
  currentPermission: string;
  thisDevice?:
    | {
        type: "notSupported";
      }
    | {
        type: "haveSubscription";
        subscription: any;
        device: string;
      }
    | {
        type: "noSubscription";
      };
  allSubscriptions?: {
    device: string;
    subscriptionData: {
      endpoint: string;
      keys: {
        auth: string;
        p256dh: string;
      };
    };
  }[];
};

const maxLengthOfEndpoint = 30;

// Bind generics to ExpandableProps and ExpandableState
export default class AdminDashboardView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      currentPermission: pushNotifications.currentPermission(),
    };

    this.initialize();
  }

  async initialize() {
    await this.getDeviceSubscriptions();
    await this.getServerSubscriptions();
  }

  async getServerSubscriptions() {
    const allSubscriptions = await pushNotifications.getServerSubscriptions(
      this.state.thisDevice
    );
    this.setState({
      allSubscriptions,
    });
  }

  async getDeviceSubscriptions() {
    const subscriptionStatus = await pushNotifications.getSubscriptionStatus();
    this.setState({
      thisDevice: subscriptionStatus,
    });
  }

  async sendNotification() {
    await pushNotifications.sendNotification(
      "hello again",
      "from readlang again 3",
      1
    );
  }

  async enableWebNotifications() {
    if (pushNotifications.currentPermission() === "denied") {
      alert(
        "Notifications appear to be blocked for this site. " +
          "Please enable notifications for this site in your browser settings."
      );
      return;
    }

    await pushNotifications.enableWebNotifications();
    this.setState({
      currentPermission: pushNotifications.currentPermission(),
    });
  }

  async setBadgeCount(to: number) {
    navigator.setAppBadge(to);
  }

  render() {
    return (
      <div>
        <h1>Admin Page</h1>

        <h2>Links</h2>
        <ul>
          <li>
            <a href="/admin/coupons">Coupons</a>
          </li>
          <li>
            <a href="/admin/users">Users</a>
          </li>
          <li>
            <a href="/admin/chats">Chats</a>
          </li>
        </ul>

        <h2>App Badge</h2>
        <p>
          <button onClick={() => this.setBadgeCount(1)}>
            Set Badge Count to 1
          </button>
          <button onClick={() => this.setBadgeCount(0)}>
            Clear Badge Count
          </button>
        </p>

        <h2>Push Notifications</h2>

        <p>Current permission: {this.state.currentPermission}</p>
        <p>
          <button onClick={() => this.enableWebNotifications()}>
            Enable Web Notifications
          </button>
        </p>

        <h3>This device</h3>
        {this.state.thisDevice ? (
          this.state.thisDevice.type === "haveSubscription" ? (
            <ul>
              <li>Device: {this.state.thisDevice.device}</li>
              <li>
                Subscription endpoint:{" "}
                {utils.elide(
                  this.state.thisDevice.subscription?.endpoint,
                  maxLengthOfEndpoint
                )}
              </li>
            </ul>
          ) : (
            <p>No subscription</p>
          )
        ) : (
          <p>Fetching...</p>
        )}

        <h3>All Subscriptions</h3>
        <table style={{ marginTop: 10 }}>
          <tr>
            <th>Device</th>
            <th>Endpoint</th>
            <th>Matches this client</th>
          </tr>
          {this.state.allSubscriptions ? (
            this.state.allSubscriptions.map((subscription) => (
              <tr>
                <td>{subscription.device}</td>
                <td title={subscription.subscriptionData.endpoint}>
                  {utils.elide(
                    subscription.subscriptionData.endpoint,
                    maxLengthOfEndpoint
                  )}
                </td>
                <td>
                  {this.state.thisDevice?.type === "haveSubscription" &&
                  subscription.subscriptionData.endpoint ===
                    this.state.thisDevice?.subscription?.endpoint
                    ? "Yes"
                    : "No"}
                </td>
              </tr>
            ))
          ) : (
            <p>Fetching...</p>
          )}
        </table>

        <p>
          <button onClick={() => this.sendNotification()}>
            Send test notification
          </button>
          <button
            onClick={() =>
              models.storedNotifications.deleteAllStoredNotifications()
            }
          >
            Clear all stored notifications
          </button>
        </p>
      </div>
    );
  }
}
